import { useEffect, useState } from "react";
import PublicGetInTouch from "./PublicGetInTouch";
import PublicBranches from "./PublicBranches";
import PublicContactForm from "./PublicContactForm";
import { usePublicSiteData } from "./PublicSiteContext";
import {
  resolveGoogleMapEmbedUrl,
  toGoogleMapEmbedUrl,
} from "../../utils/GoogleMap";

const PublicContactPage = () => {
  const website = usePublicSiteData();
  const googleMapsUrl = website?.organization.googleMapsUrl ?? null;
  const [embedUrl, setEmbedUrl] = useState<string | null>(() =>
    toGoogleMapEmbedUrl(googleMapsUrl),
  );

  useEffect(() => {
    let active = true;
    resolveGoogleMapEmbedUrl(googleMapsUrl).then((url) => {
      if (active) setEmbedUrl(url);
    });
    return () => {
      active = false;
    };
  }, [googleMapsUrl]);

  return (
    <>
      <section className="psite-page-hero">
        <div className="psite-page-hero__inner">
          <h1>Contact</h1>
          <p>We would love to hear from you.</p>
        </div>
      </section>

      <section className="psite-section">
        <div className="psite-section__inner">
          <div className={embedUrl ? "psite-contact-grid" : ""}>
            <PublicContactForm />

            {embedUrl && (
              <div className="psite-contact-map">
                <iframe
                  title="Organization location on Google Maps"
                  src={embedUrl}
                  loading="lazy"
                  allowFullScreen
                  referrerPolicy="no-referrer-when-downgrade"
                />
                {googleMapsUrl && (
                  <a
                    className="psite-btn psite-btn--secondary"
                    href={googleMapsUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Open in Google Maps
                  </a>
                )}
              </div>
            )}
          </div>
        </div>
      </section>

      <PublicGetInTouch />
      <PublicBranches />
    </>
  );
};

export default PublicContactPage;